import { LogoutService } from './../../login/services/logout.service';
import { LoginValidationService } from './../../login/services/login-validation.service';
import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class ProveedorGuard implements CanActivate {
  constructor(
    private router: Router,
    private _logout: LogoutService,
    private _loginVal: LoginValidationService
  ) {}

  canActivate() {
    const userPermissions = this._loginVal.getUserRoles();
    const proveedorPerms = [1012];

    const foundProveedor = proveedorPerms.some(
      (r) => userPermissions.indexOf(r) >= 0
    );

    if (foundProveedor) {
      return true;
    } else {
      this.router.navigate(['login']);
      this._logout.logOut();
      return false;
    }
  }
}
